import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Fai clic sul pulsante qui sotto per rivedere e confermare le informazioni di pagamento.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Collaboriamo con Stripe per gestire i pagamenti. Stripe è la piattaforma di pagamento più sicura, utilizzata dalle maggiori aziende in tutto il mondo.',
      form: {
        terms_acceptance: {
          label:
            'Procedendo, accetti il nostro <FoodAmigosTerms>Contratto di servizio</FoodAmigosTerms> e il <StripeTerms>Contratto per account connessi Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'Stripe ha ancora bisogno dei dati qui sotto oppure non è riuscito a verificarli:',
        errors: 'Errori',
        awaiting_verification: 'Il tuo account Stripe è in fase di verifica',
        awaiting_verification_description:
          'Stiamo attendendo che Stripe completi la verifica della tua attività. Nel frattempo puoi consultare il tuo profilo.',
        details_hint:
          'Stripe verifica nomi, indirizzi e numeri di telefono con i registri ufficiali. Se uno è sbagliato, correggilo in Le mie info → Informazioni Personali e Stripe lo verificherà di nuovo. Tutto il resto che Stripe richiede puoi aggiungerlo nel tuo profilo Stripe.',
        requirements_hint:
          "Alcuni di questi sono documenti, come il tuo documento d'identità: caricali nel passaggio precedente, {{step}}, poi torna qui.",
        requirements_hint_profile:
          "Alcuni di questi sono documenti, come il tuo documento d'identità: caricali nel tuo profilo Stripe.",
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Titolare',
          representative: 'Rappresentante',
          business: 'Attività',
        },
        details: {
          first_name: 'Nome',
          last_name: 'Cognome',
          email: 'Email',
          phone: 'Numero di telefono',
          dob: 'Data di nascita',
          id_number: 'Numero di documento',
          nationality: 'Nazionalità',
          address: 'Via e numero civico',
          city: 'Città',
          postal_code: 'Codice postale',
          state: 'Provincia',
          country: 'Paese',
          id_document: "Documento d'identità",
          proof_of_address: 'Prova di residenza',
          job_title: 'Qualifica',
          business_name: 'Ragione sociale',
          tax_id: 'Codice fiscale',
          vat_id: 'Partita IVA',
          registration_number: 'Numero di registrazione',
          website: 'Sito web',
          industry: 'Settore',
          product_description: 'Descrizione di ciò che vendi',
          support_phone: "Numero di telefono dell'assistenza clienti",
          owners: 'Conferma dei titolari',
          directors: 'Conferma degli amministratori',
          executives: 'Conferma dei dirigenti',
          registration_document: "Documento di registrazione dell'attività",
          bank_account: 'Conto bancario per i pagamenti',
          business_type: 'Tipo di attività',
          terms: 'Accettazione dei termini di Stripe',
          bank_account_proof: 'Prova di proprietà del conto bancario',
          tax_id_document: 'Documento del codice fiscale',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Collaboriamo con Adyen per la gestione dei pagamenti. Adyen è una delle piattaforme di pagamento più sicure, utilizzata dalle più grandi aziende al mondo.',
    },
  },
  labels: {
    verified: 'Il tuo account {{paymentGateway}} è verificato',
    verified_description:
      'La verifica per {{paymentGateway}} è completata. Puoi comunque gestire il tuo profilo se necessario.',
  },
  buttons: {
    proceed: 'Conferma le mie informazioni di pagamento',
    copy_link: 'Copia link',
    back: 'Indietro',
  },
  toasts: {
    something_went_wrong: 'Si è verificato un errore, contatta il supporto tecnico',
  },
};
